import createFetch from "./fetch"
import { API_PREFIX_MAP } from './constant'

class PluginOptions {
  /**
   * apiFetch 和 apiPrefix、apiOptions是互斥的，当 apiFetch 存在时，将忽略 apiPrefix, apiOptions
   * @param {*} param0
   */
  constructor ({ useLoader, apiFetch, apiPrefix, apiOptions, envMode, fixPluginName }) {
    this.useLoader = useLoader
    this.apiPrefix = apiPrefix || ''
    this.apiOptions = apiOptions
    this.envMode = envMode
    this.envProxy = API_PREFIX_MAP[envMode]
    this.fixPluginName = fixPluginName
    this.fetch = apiFetch ? this.apiFetchWrapper(apiFetch) : this.apiFetchWrapper(createFetch({ urlPrefix: this.apiPrefix, axiosOptions: apiOptions }))
  }
  apiFetchWrapper (apiFetch) {
    const apiOptions = this.apiOptions
    const envProxy = this.envProxy
    return function (...args) {
      if (!(Array.isArray(args) && args.length > 0)) {
        throw new Error('apiFetch must have a arguments')
      }

      // eslint-disable-next-line camelcase
      let { url, method, options, cc_com_options } = args[0] || {}
      const _options = options || apiOptions || {}
      // eslint-disable-next-line camelcase
      const { pluginInfo } = cc_com_options
      const { pluginName } = pluginInfo || {}

      // eslint-disable-next-line camelcase

      console.log(`[@ccprivate/plugin-engine-saas][plugin-core] fetchWrapper: ${method} ${url}`)

      if (url.startsWith('cc-plugin') || url.startsWith('/cc-plugin')) {
        if (pluginName) {
          // 因为，目前所有插件的接口都是通过 "cc-plugin/plugins/插件名称/插件接口名称" 形式进行调用
          // 所以，当插件名称 pluginName 存在时，将url 中代表插件的标识（插件名称）改为动态获取
          // eslint-disable-next-line no-useless-escape
          url = url.replace(/cc-plugin\/plugins\/([^\/]+)\/(.*)/, `cc-plugin/plugins/${pluginName}/$2`)
        }
        if (envProxy) {
          _options.url = `${envProxy}/${url}`
        }
      }
      args[0].options = _options
      return apiFetch(...args)
    }
  }
}

let instance

/**
 *
 * @param {{ useLoader: boolean, fetch: function }} options
 * @returns
 */
export function createPluginOptions (options) {
  if (!instance) {
    instance = new PluginOptions(options)
  }
  return instance
}

export function getPluginOptions () {
  if (!instance) {
    throw new Error('Please run `createPluginOptions()` before `getPluginOptions()`;')
  }
  return instance
}
